import { useTranslations } from '@aikoa/i18n/react'
import { Link, Stack, useGlobalSearchParams, usePathname } from 'expo-router'
import { useEffect } from 'react'
import { ErrorBoundary } from '~/components/ErrorBoundary'
import ContentBox from '~/components/layout/ContentBox'
import { Text } from '~/components/ui/text'
import { usePostHog } from '~/lib/analytics/posthog'

export default function NotFoundScreen() {
  const { t } = useTranslations('common')
  const posthog = usePostHog()
  const pathname = usePathname()
  const searchParams = useGlobalSearchParams()

  useEffect(() => {
    if (!posthog) {
      return
    }

    posthog.capture('route_not_found', {
      route: pathname,
      search_params: JSON.stringify(searchParams),
    })
  }, [pathname, posthog, searchParams])

  return (
    <ErrorBoundary>
      <>
        <Stack.Screen options={{ title: t(($) => $.notFound.title) }} />
        <ContentBox className="items-center justify-center">
          <Text className="font-bold text-lg">{t(($) => $.notFound.message)}</Text>
          <Link className="mt-4 pt-4" href="/">
            <Text className="text-base text-[#2e78b7]">{t(($) => $.notFound.goHome)}</Text>
          </Link>
        </ContentBox>
      </>
    </ErrorBoundary>
  )
}
